<template>
<v-dialog v-model="dialog" max-width="800px" scrollable persistent :fullscreen="$vuetify.breakpoint.smAndDown">
    <v-card>
        <v-card-title>
            <div class="d-flex align-center">
                <v-icon class="pr-2" color="primary">view_module</v-icon>
                <div class="important">{{ $t('sheet.inventory_modal.tittle') }}</div>
            </div>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
            <div class="pb-2">
                <div class="py-1">
                    <span class="title pr-1">{{ $t('sheet.inventory_modal.apply') }}</span>
                    <span class="subheading">{{ $t('sheet.inventory_modal.message.room_selection') }}</span>
                </div>
                <v-row class="mx-0 py-1">
                    <template v-for="room in room_types">
                        <v-btn class="ma-1" v-if="!room.close_out" :color="rooms.includes(room.id) ? 'primary' : 'grey lighten-2'" small @click="selectionRooms(room.id)">
                            <v-icon v-if="rooms.includes(room.id)" color="green">done</v-icon>
                            <span class="text-capitalize">{{room.name}}</span>
                        </v-btn>
                    </template>
                </v-row>
            </div>
            <v-divider></v-divider>
            <div class="py-1">
                <div>
                    <span class="title pr-1">{{ $t('sheet.inventory_modal.valibility_and_weekdays') }}</span>
                    <span class="subheading">{{ $t('sheet.inventory_modal.message.past_days') }}</span>
                </div>
                <div class="d-flex">
                    <v-menu transition="scale-transition" offset-y min-width="max-content">
                        <template v-slot:activator="{ on }">
                            <v-text-field v-on="on" v-model="period.start" :label="$t('sheet.inventory_modal.start_date')" prepend-icon="event" readonly></v-text-field>
                        </template>
                        <v-date-picker v-model="period.start" :min="today" no-title width="265"></v-date-picker>
                    </v-menu>
                    <v-menu transition="scale-transition" offset-y min-width="max-content">
                        <template v-slot:activator="{ on }">
                            <v-text-field v-on="on" v-model="period.stop" :label="$t('sheet.inventory_modal.end_date')" prepend-icon="arrow_right_alt" readonly></v-text-field>
                        </template>
                        <v-date-picker v-model="period.stop" :min="period.start" no-title width="265"></v-date-picker>
                    </v-menu>
                </div>
                <v-row class="mx-0 pb-2">
                    <v-btn v-for="(day,index) in days" :key="index" small rounded depressed class="weekend-days regular mx-1" :color="weekdays.includes(day.value) ? 'primary' : 'grey lighten-2'" @click="selectDays(day.value)">
                        <span class="text-capitalize">{{ $t('week_days_short.' + day.text) }}</span>
                    </v-btn>
                </v-row>
            </div>
            <v-divider></v-divider>
            <div class="">
                <div class="py-1">
                    <span class="title pr-1">{{ $t('sheet.inventory_modal.disponibility_and_restrictions') }}</span>
                    <span class="subheading">{{ $t('sheet.inventory_modal.message.disponibility_and_restrictions') }}</span>
                </div>
                <v-row>
                    <v-col class="py-0" md="6" cols="12">
                        <div class="justify-center d-flex py-1">
                            <v-btn color="primary" :outlined="!availability" @click="availability=!availability">{{ $t('sheet.inventory_modal.disponibility') }}</v-btn>
                        </div>
                        <div>
                            <v-text-field :label="$t('sheet.inventory_modal.room_disponibility')" v-model="count" class="pr-5" :disabled='!availability'></v-text-field>
                        </div>
                    </v-col>
                    <v-col class="py-0" md="6" cols="12">
                        <div class="justify-center d-flex py-1">
                            <v-btn :color="open ? 'primary' : 'primary'" :outlined="!open" @click="open=!open">{{ $t('sheet.inventory_modal.restrictions') }}</v-btn>
                        </div>
                        <div class="d-flex justify-space-around py-1">
                            <v-btn :outlined="close_all" color="green" :disabled='!open' @click="close_all=!close_all">{{ $t('sheet.inventory_modal.open') }}</v-btn>
                            <v-btn :outlined="!close_all" color="red" :disabled='!open' @click="close_all=!close_all">{{ $t('sheet.inventory_modal.close') }}</v-btn>
                        </div>
                    </v-col>
                </v-row>
            </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="px-2">
            <v-spacer></v-spacer>
            <v-btn text @click="emitExit()">
                {{ $t('button.cancel') }}
            </v-btn>
            <v-btn color="primary" :loading="loading" :disabled="!save_status" @click="save">
                {{ $t('button.update') }}
            </v-btn>
        </v-card-actions>
    </v-card>
</v-dialog>
</template>

<script>
import {
    mapActions
} from 'vuex';

export default {
    name: `inventory-card`,

    props: {
        room_id: [Number, String],
        hotel_id: Number,
        room_types: Array,
        dialog: Boolean,
        date_period: {
            type: Object,
            default () {
                return {
                    start: null,
                    stop: null
                }
            }
        }
    },
    data() {
        return {
            period: {
                start: this.date_period.start,
                stop: this.date_period.stop
            },
            today: new Date()
                .toISOString()
                .substr(0, 10),
            active: null,
            loading: false,
            count: null,
            availability: false,
            open: false,
            close_all: false,
            rooms: [],
            weekdays: [0, 1, 2, 3, 4, 5, 6],
            days: [{
                    text: "monday",
                    value: 1
                }, {
                    text: "tuesday",
                    value: 2
                }, {
                    text: "wednesday",
                    value: 3
                }, {
                    text: "thursday",
                    value: 4
                }, {
                    text: "friday",
                    value: 5
                }, {
                    text: "saturday",
                    value: 6
                }, {
                    text: "sunday",
                    value: 0
                }
            ],
        }
    },
    watch: {
        // reset to default values
        dialog: {
            handler(newVal, oldVal) {
                if(newVal == true) {
                    if(this.room_id) {
                        this.rooms = [this.room_id];
                    } else {
                        this.rooms = [];
                    }
                }
            }
        },
        date_period: {
            handler() {
                this.period = {
                    'start': this.date_period.start,
                    'stop': this.date_period.stop
                };
            }
        },
        'period.start'(newVal) {
            let value = this.$moment(this.period.start)
                .isBefore(this.period.stop)
            if(!value) {
                this.period.stop = null;
            }
        }
    },

    computed: {
        save_status() {
            return ((this.availability && (this.count !== null)) || this.open) && (this.period.start !== null && this.period.stop !== null) && (this.rooms.length > 0)
        },
    },

    methods: {
        ...mapActions('alert', ['success', 'error']),

        emitExit() {
            this.$emit('close');
            this.rooms = [];
            this.weekdays = [0, 1, 2, 3, 4, 5, 6];
            this.active = null;
            this.count = null;
            this.availability = false;
            this.open = false;
            this.close_all = false;
            this.period = {
                'start': this.date_period.start,
                'stop': this.date_period.stop
            };
        },

        selectionRooms(value) {
            if(this.rooms.includes(value)) {
                let index = this.rooms.indexOf(value);
                if(index > -1) {
                    this.rooms.splice(index, 1);
                }
            } else {
                this.rooms.push(value)
            }
        },

        selectDays(value) {
            if(this.weekdays.includes(value)) {
                let index = this.weekdays.indexOf(value);
                if(index > -1) {
                    this.weekdays.splice(index, 1);
                }
            } else {
                this.weekdays.push(value)
            }

        },

        save() {
            this.loading = true;
            if(this.open) {
                this.active = !this.close_all;
            } else {
                this.active = null;
            }

            if(!this.availability) {
                this.count = null;
            }
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === 'true' ? 'https://' : 'http://';
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + '/api/services-new/console/v1/inventory/bulk-update';

            // setup query params
            let params = {
                hotel_id: this.hotel_id,
                inventory: this.rooms,
                date_start: this.period.start,
                date_stop: this.period.stop,
                weekdays: this.weekdays,
                count: this.count
            };
            if(this.open) {
                params.close_out = this.close_all;
            }
            this.$axios.post(endpoint, params)
                .then(response => {
                    this.success(this.$t('sheet.inventory_modal.message_updated'));
                    this.emitExit();
                    this.$emit('refresh');
                })
                .catch(error => {
                    this.error('Ooops, something gone wrong');
                    console.log(error);
                })
                .finally(() => {
                    this.loading = false;
                });
        }
    }
}
</script>
<style lang="stylus">
.weekend-days
    &.v-btn
        min-width: 55px
</style>
